import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
// TODO:Spartacus - // TODO:Spartacus - Variable userAccountTranslations has been removed and is no longer part of the public API. 
import { userAccountTranslationChunksConfig, userAccountTranslationsEn } from '@spartacus/user/account/assets';
import { UserAccountRootModule } from '@spartacus/user/account/root';
// TODO:Spartacus - // TODO:Spartacus - Variable userProfileTranslations has been removed and is no longer part of the public API. 
import { userProfileTranslationChunksConfig, userProfileTranslationsEn } from '@spartacus/user/profile/assets';
import { UserProfileRootModule } from '@spartacus/user/profile/root';

@NgModule({
  declarations: [],
  imports: [
    UserAccountRootModule,
    UserProfileRootModule
  ],
  // tslint:disable-next-line:no-angle-bracket-type-assertion
  providers: [provideConfig(<CmsConfig> {
    featureModules: {
      userAccount: {
        module: () =>
          import('@spartacus/user/account').then((m) => m.UserAccountModule),
      },
    }
  }),
  // tslint:disable-next-line:no-angle-bracket-type-assertion
  provideConfig(<I18nConfig> {
    i18n: {
      resources: {en: userAccountTranslationsEn},
      chunks: userAccountTranslationChunksConfig,
    },
  }),
  // tslint:disable-next-line:no-angle-bracket-type-assertion
  provideConfig(<CmsConfig> {
    featureModules: {
      userProfile: {
        module: () =>
          import('@spartacus/user/profile').then((m) => m.UserProfileModule),
      },
    }
  }),
  // tslint:disable-next-line:no-angle-bracket-type-assertion
  provideConfig(<I18nConfig> {
    i18n: {
      resources: {en: userProfileTranslationsEn},
      chunks: userProfileTranslationChunksConfig,
    },
  })
  ]
})
export class UserFeatureModule { }
